// Records a view of a certified catch video. The backend dedups per viewer
// (server-only videos/{certId}/viewers/{uid}) and never counts the uploader's
// own views, so callers can fire this freely on playback. Never throws.
import { auth } from "../firebase";
import { resolveApiBaseUrl } from "./apiBase";

export async function recordVideoView(certId) {
  if (!certId) return { counted: false };
  const user = auth?.currentUser;
  if (!user) return { counted: false };
  try {
    const token = await user.getIdToken();
    const res = await fetch(`${resolveApiBaseUrl()}/v1/video/view`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ certId }),
    });
    if (!res.ok) return { counted: false };
    return await res.json();
  } catch {
    return { counted: false };
  }
}
